import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

const campaignCardAllowed = () => hasSoftDeployAccess('REACT_CAMPAIGN_CARD');

export default campaignCardAllowed;
